import React, { useEffect, useState } from "react";
import styles from "./scss/profileFrame.module.scss";
import LeftsideBars from "../profile/leftsidebar";
import TopHeader from "../chat/chatsection/topheader";

// import CallsInnerLogs from "./profileWidgets/profileInnerLogs";
import SettingInnerLogs from "./profileWidgets/settingInnerLogs";
import ProfileInnerLogs from "./profileWidgets/profileInnerLogs";
import ProfileInnerEdit from "./profileWidgets/profileInnerEdit";
import MainMenus from "../../common/menus";

import { chatSDK } from "unifiedring-sdk";
import { profileDetails } from "../../models/model";
import { useSelector } from "react-redux";
import store from "../../context/store/store";
import ToastLeft from '../../shared/widgets/toastScreenleft';
import { Types } from "../../context/action/action";
//import { toastReducer } from "../../context/reducer/toastReducer";
import { callMainPageInterface } from "../../models/callModel";
import VideoMeetSetting from "./profileWidgets/videoMeetSetting";
import { getVideoMeetSetting } from "../../base/eventService/eventApiService";
import Privateappindex from "../../new pages/privateapp/privateappindex";

type profileMainState ={
  isActive:boolean;
  isActiveExapnd:boolean;
  isActiveone:boolean;
  isActiveMini:boolean;
  isTransc:boolean;
  openprofile:Number;
  profileData:any;
  userStatus:any;
}
 
export default function URProfileMainFrame() {

  const [mainProfile, setmainProfile] = useState<profileMainState>({
    isActive:false,
    isActiveExapnd:false,
    isActiveone:false,
    isActiveMini:false,
    isTransc:false,
    openprofile:0,
    profileData:{},
    userStatus:''
  });

  const {  toastReducer}: callMainPageInterface =  useSelector((state: callMainPageInterface) => state);
  const profileUserDetails:  profileDetails = useSelector((state: any) => state.profileReducer);
 
  const {isprofile,profileData,isUserStatus,userStatusData,
    isemergencyAddressData,emergencyAddressData,isSettingTab,isvideoprofile}=profileUserDetails;
  const mainProgram = (value:any)=>{
    setmainProfile({...mainProfile,openprofile:value});
  };
  const handleToggleone = () => {
    setmainProfile({...mainProfile,isActiveone:!mainProfile.isActiveone});
  };
  //const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const getVideoSetting = () =>{
    getVideoMeetSetting();
  }

  const getUserProfileApi = () =>
  {
  
    new chatSDK.ChatRestService().profileInfo().then((response: any) =>
    {

      
      if(response?.statusCode === 200) {

      
        store.dispatch({
          type: Types.PROFILE_DETAIL,
          payload: {
            isprofile:true,
            profileData:response.profile_info
          }
        });
     
      }
    });
  
    
  };
  const settingsData = ()=>{
   
    new chatSDK.ChatRestService().getEmergNumber().then((res)=>{
   
      if(res.statusCode===200){
        if(res.result.length > 0 ){


          let  emergencyAddressData={
            buildingName:res.result[0].address_line_1,
            streetName:res.result[0].address_line_2,
            city:res.result[0].city,
            country:res.result[0].country,
            pinCode:res.result[0].post_code};
          store.dispatch({
            type: Types.EMERGENCY_ADDRESS,
            payload:{emergencyAddressData:emergencyAddressData,
              isemergencyAddressData:true}
          });
      
        }
          
      }
       
    });
  };
  const getUserPrescence = ()=>{

    new chatSDK.ChatRestService().userGetStatus()
      .then((data:any) => {
        
        if(data?.statusCode === 200){
         
          let USerstatus :any= data.user_status.status_msg;
          let decoded :any= data.user_status.status_msg;
          if(decoded.includes('++')) {
            decoded = decoded.split("++")[1];
            USerstatus = decodeURIComponent(decoded.replace(/\+/g,  " "));
          }
        
         
         
          store.dispatch({
            type: Types.USER_STATUS,
            payload: {
              userStatusData: USerstatus,
              isUserStatus:true
              
            }
          });
 
         
        }
        
      });
   
  };
  useEffect(() => {
    if(!isprofile){
      getUserProfileApi();
      
    }
    if(!isUserStatus){
      getUserPrescence();
    }
    if(!isemergencyAddressData){
      settingsData();
    }
    if(!isvideoprofile){
      getVideoSetting();
    }
    
   
  }, []);
  
  return (
    <>
      <div className={styles.mainframe}>
        <div className={styles.framemenu}>
          <MainMenus></MainMenus>
        </div>
        <div className={mainProfile.isActiveone ?
          `${styles.frameleftsidebar}` : mainProfile.isTransc? `${styles.frameleftsidebar}
           ${styles.frameleftsidebarhide}`  :`${styles.frameleftsidebar} ${styles.hideframeleftsidebar}`}>
          <div className={styles.mobilemenu} onClick={handleToggleone}><span className="icon_close"></span></div>
          <LeftsideBars mainProgram={mainProgram}></LeftsideBars>
        </div>
        <div className={mainProfile.isTransc? `${styles.framemain} ${styles.framemainfull}` : `${styles.framemain}`}>
          <div className={styles.frameheader}>
            <div className={styles.mobilemenu} onClick={handleToggleone}>Menus</div>
            <TopHeader></TopHeader>
          </div>
          <div className={mainProfile.isActive ? `${styles.framemainsection}
           ${styles.framecolappse} ` : mainProfile.isActiveExapnd ? `${styles.framemainsection} 
           ${styles.framehide}` :  mainProfile.isActiveMini ? `${styles.miniCallWinidow}`: mainProfile.isTransc ?
            `${styles.framemainsection} ${styles.framwidthhalf}` : `${styles.framemainsection}`}>
            <div className={styles.chatmainsections}>
              <div className={`scroller ${styles.chatinnerframe}`}>
                {mainProfile.openprofile === 0  && isSettingTab === 'profile' &&< ProfileInnerLogs
                
                  setProfileData={mainProgram}/>}
                
                {(mainProfile.openprofile === 1 || isSettingTab === 'setting' )&&
                 <SettingInnerLogs emergencyAddressDataProps={emergencyAddressData}
                   profileData={profileData}/>}
                {mainProfile.openprofile === 2 && < ProfileInnerEdit profileData={profileData}
                  userStatus={userStatusData} mainProgram={mainProgram}  emergencyAddressDataProps={emergencyAddressData}/>}

              {mainProfile.openprofile === 3 &&  <VideoMeetSetting/>}
              {mainProfile.openprofile ===  4 && <Privateappindex/>}
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastReducer.isLeftToast && <ToastLeft/>}
    </>
  );
};